import { createContext, useContext } from "react";

/**
 * The workbench the stage's next step is on, and the criterion it serves, so that the one control doing that step – and only it – shows
 * as the screen's gold button. Unset when the next step is anywhere else.
 */
export const NextStepSurface = createContext<{ surface: string; criterion: string | null } | null>(null);

/** Whether the stage's next step is on the given workbench (and, when named, for the given criterion). */
export function useIsNextStep(surface: string, criterion?: string) {
  const next = useContext(NextStepSurface);
  return !!next && next.surface === surface && (criterion === undefined || next.criterion === criterion);
}
